import React from 'react';
import PropTypes from 'prop-types';

import {
    Flex,
    token,
} from '@zillow/constellation';

import {
    StyledText,
    StyledStepContainer,
    StyledCustomStep,
    StyledActiveStep,
    StyledIconCheckmark,
} from './StyledComponents';

const propTypes = {
    index: PropTypes.number, // Passed by ProgressStepper
    activeIndex: PropTypes.number, // Passed by ProgressStepper
    isMobile: PropTypes.bool, // Passed by ProgressStepper, false by default
    isCompleted: PropTypes.bool, // Passed by ProgressStepper, false by default
    isActive: PropTypes.bool, // Passed by ProgressStepper, false by default
    label: PropTypes.string,
    mobileLabel: PropTypes.string,
};

const defaultProps = {
    index: -1,
    activeIndex: -1,
    isMobile: false,
    isCompleted: false,
    isActive: false,
    label: '',
    mobileLabel: '',
};

const Step = ({
    isMobile,
    isCompleted,
    isActive,
    activeIndex,
    index,
    label,
    mobileLabel,
}) => {
    const renderDot = () => {
        if (isActive) {
            return <StyledActiveStep />;
        }

        const borderColor = index > activeIndex ? token('colors.gray300') : token('colors.brand');
        if (isCompleted) {
            return (
                <StyledCustomStep backgroundColor={borderColor} borderColor={borderColor}>
                    <StyledIconCheckmark />
                </StyledCustomStep>
            );
        }
        return (
            <StyledCustomStep backgroundColor={token('colors.white')} borderColor={borderColor} />
        );
    };

    return (
        <Flex display="flex" flexDirection="column" alignItems="center">
            <StyledStepContainer isActive={activeIndex === index}>
                {renderDot()}
            </StyledStepContainer>
            {label && (
                <StyledText fontType="fineprint" isBold={activeIndex === index}>
                    {isMobile ? mobileLabel : label}
                </StyledText>
            )}
        </Flex>
    );
};

Step.propTypes = propTypes;
Step.defaultProps = defaultProps;

export { Step };
export default Step;
